(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ella-home-ranked"] && !Shopify.designMode) return;
  try {
    
(() => {
  async function loadRanked(section) {
    if (section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';
    const grid = section.querySelector('[data-ranked-products]');
    if (!grid || grid.children.length) return;
    try {
      const link = section.querySelector('.ella-home-ranked__heading > a');
      const url = new URL(link.href);
      url.searchParams.set('section_id', 'ella-home-ranked');
      const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      const response = await fetch(url.pathname + url.search, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('ranked products');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const products = html.querySelector('[data-ranked-products]');
      if (!products || !products.children.length) throw new Error('ranked products missing');
      products.querySelectorAll('image-element[data-aos]').forEach(image => {
        image.removeAttribute('data-aos');
        image.removeAttribute('data-aos-offset');
      });
      grid.replaceChildren(...products.children);
      grid.removeAttribute('aria-busy');
    } catch (error) {
      grid.removeAttribute('aria-busy');
      grid.hidden = true;
      section.dataset.loaded = 'false';
    }
  }
  function initRanked() {
    document.querySelectorAll('[data-ella-home-ranked]').forEach(section => {
      if (section.dataset.observed === 'true') return;
      section.dataset.observed = 'true';
      if (!('IntersectionObserver' in window)) { loadRanked(section); return; }
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        loadRanked(section);
      }, { rootMargin: '400px' });
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRanked, { once: true });
  else initRanked();
  document.addEventListener('shopify:section:load', initRanked);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ella-pflegeroutine"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ella-pflegeroutine')) {
  customElements.define('ella-pflegeroutine', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.goal = this.querySelector('[data-goal]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.button = this.querySelector('[data-add]');
      this.message = this.querySelector('[data-message]');
      this.addEventListener('change', () => this.update());
      this.button.addEventListener('click', () => this.add());
      const initialGoal = new URLSearchParams(window.location.search).get('ziel');
      if (['repair','volume','curl'].includes(initialGoal)) this.goal.value = initialGoal;
      this.update();
    }
    selected() {
      return this.cards.filter(c => !c.hidden && c.querySelector('[data-pick]').checked && !c.querySelector('[data-pick]').disabled);
    }
    update() {
      this.cards.forEach(c => {
        c.hidden = c.dataset.goal !== this.goal.value;
        if (c.hidden) c.querySelector('[data-pick]').checked = false;
      });
      const total = this.selected().reduce((sum,c) => sum + Number(c.querySelector('[data-variant]').selectedOptions[0].dataset.price), 0);
      this.querySelector('[data-total]').textContent = new Intl.NumberFormat('de-DE', {style:'currency',currency:this.dataset.currency}).format(total/100);
      this.button.disabled = this.busy || this.selected().length === 0;
      this.message.textContent = '';
    }
    async add() {
      if (this.busy) return;
      const items = this.selected().map(c => ({id:c.querySelector('[data-variant]').value,quantity:1}));
      if (!items.length) return;
      this.busy = true;
      this.querySelectorAll('select,input').forEach(e => {e.dataset.wasDisabled = String(e.disabled);e.disabled = true;});
      this.button.disabled = true;
      this.message.textContent = 'Deine Auswahl wird hinzugefügt …';
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Bitte prüfe deine Auswahl im Warenkorb.');
        window.location.assign(root+'cart');
      } catch (error) {
        this.message.textContent = 'Bitte prüfe den Warenkorb vor einem erneuten Versuch. '+error.message;
        this.busy = false;
        this.querySelectorAll('select,input').forEach(e => {e.disabled = e.dataset.wasDisabled === 'true';});
        this.button.disabled = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ella-product-pairings"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const text = JSON.parse(root.querySelector('[data-pairing-texts]').textContent);
    const rules = JSON.parse(root.dataset.rules || 'null') || {};
    const main = document.querySelector('[data-ella-pdp-ux]');
    const sourceSelection = () => {
      if (main) return [...main.querySelectorAll('[data-shade-card]')].filter(c => Number(c.querySelector('[data-card-quantity]')?.textContent) > 0).map(c => c.dataset.variantId);
      const value = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      return value ? [String(value)] : [];
    };
    const cards = [...root.querySelectorAll('[data-pairing-card]')];
    cards.forEach(card => {
      const data = JSON.parse(card.dataset.variants);
      const select = card.querySelector('[data-pairing-select]');
      const quantity = card.querySelector('[data-pairing-quantity]');
      const button = card.querySelector('[data-pairing-add]');
      const delivery = card.querySelector('[data-pairing-delivery]');
      const message = card.querySelector('[data-pairing-message]');
      const initialPrice = card.querySelector('[data-pairing-price]').textContent;
      const image = card.querySelector('img');
      const initialImage = image?.getAttribute('src');
      let loading = false, adding = false;
      const constraints = rules.targets?.[card.dataset.productId] || rules.targets?.['gid://shopify/Product/' + card.dataset.productId];
      const optionAllowed = id => {
        if (card.dataset.kind !== 'system') return true;
        if (!constraints) return false;
        const selected = sourceSelection();
        
        return selected.length ? selected.every(s => (constraints.bySource?.[s] || []).includes(String(id))) : (constraints.allowed || []).includes(String(id));
      };
      const rebuild = () => {
        const previous = select.value;
        select.replaceChildren(new Option(text.choose, ''));
        data.variants.forEach(v => {
          const option = new Option(v.title === 'Default Title' ? card.dataset.title : v.title, v.id);
          option.disabled = !optionAllowed(v.id);
          if (option.disabled) option.hidden = true;
          select.append(option);
        });
        if (data.variants.some(v => v.id === previous && optionAllowed(v.id))) select.value = previous;
        card.hidden = card.dataset.kind === 'system' && sourceSelection().length > 0 && !data.variants.some(v => optionAllowed(v.id));
      };
      const update = () => {
        const variant = data.variants.find(v => v.id === select.value);
        const chosen = Number(quantity.value);
        const validAmount = Number.isInteger(chosen) && chosen >= Number(quantity.min) && (!quantity.max || chosen <= Number(quantity.max)) && (chosen - Number(quantity.min)) % Number(quantity.step) === 0;
        const sourceMissing = false;
        button.disabled = adding || loading || !variant || !variant.available || variant.sellingPlan || !validAmount || !optionAllowed(variant.id);
        button.textContent = text.add;
        if (!variant) {
          card.querySelector('[data-pairing-price]').textContent = initialPrice;
          card.querySelector('[data-pairing-unit]').textContent = '';
          delivery.textContent = sourceMissing ? text.source : text.choose;
          delivery.dataset.preorder = 'false';
          quantity.removeAttribute('max');
          if (image && initialImage) { image.removeAttribute('srcset'); image.src = initialImage; image.alt = card.dataset.title; }
          return;
        }
        const min = variant.min || 1;
        quantity.min = min; quantity.step = variant.increment || 1;
        let maximum = variant.max || null;
        if (variant.tracked && variant.policy !== 'continue') maximum = maximum === null ? Math.max(0, variant.stock) : Math.min(maximum, Math.max(0, variant.stock));
        if (maximum !== null) quantity.max = maximum; else quantity.removeAttribute('max');
        const valid = Number.isInteger(chosen) && chosen >= min && (maximum === null || chosen <= maximum) && (chosen-min) % (variant.increment||1) === 0;
        button.disabled = adding || loading || !variant.available || variant.sellingPlan || !valid || !optionAllowed(variant.id);
        card.querySelector('[data-pairing-price]').textContent = variant.price;
        card.querySelector('[data-pairing-unit]').textContent = variant.unit;
        if (image) {image.removeAttribute('srcset');image.src = variant.image || initialImage;image.alt = variant.alt || card.dataset.title;}
        const preorder = variant.available && variant.tracked && variant.policy === 'continue' && variant.stock < chosen;
        button.textContent = !variant.available ? text.soldout : preorder ? text.preorder : text.add;
        delivery.dataset.preorder = String(preorder);
        if (!variant.available) delivery.textContent = text.soldout;
        else if (data.policy === 'product') delivery.textContent = preorder ? text.genericPreorder : text.genericAvailable;
        else delivery.textContent = preorder ? text.preorderDelivery : data.policy === 'pallet' ? text.palletDelivery : text.stockDelivery;
        if (variant.sellingPlan) {button.disabled = true;delivery.textContent = text.incompatible;}
      };
      card.refresh = () => {rebuild();update();};
      card.refresh();
      select.addEventListener('change', () => {const v = data.variants.find(v => v.id === select.value);quantity.value = v?.min || 1;message.textContent='';update();});
      quantity.addEventListener('input', update);
      let next = data.next;
      const loadRemaining = async () => {
        if (!next || loading) return;
        loading=true;update();
        try {
          while (next) {
            const url = new URL(next, location.origin);
            url.pathname = card.dataset.url.split('?')[0];url.searchParams.set('view','ella-pairing-data');url.searchParams.delete('section_id');url.searchParams.delete('sections');
            const response = await fetch(url.pathname + url.search, {credentials:'same-origin'});
            if (!response.ok) throw new Error(text.error);
            const page = await response.json();
            const seen = new Set(data.variants.map(v=>v.id));const added = page.variants.filter(v=>!seen.has(v.id));
            if (!added.length) throw new Error(text.error);
            data.variants.push(...added);next=page.next;
          }
          rebuild();
        } catch (_) {message.textContent=text.error;message.dataset.error='true';}
        finally {loading=false;update();}
      };
      if (next) loadRemaining();
      card.querySelector('form').addEventListener('submit', async event => {
        event.preventDefault();update();
        if (button.disabled || !event.target.reportValidity()) return;
        adding=true;update();button.setAttribute('aria-busy','true');message.textContent='';
        try {
          const route=(window.Shopify?.routes?.root||'/')+'cart/add.js';
          const response=await fetch(route,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:Number(quantity.value)}]})});
          const result=await response.json();
          if (!response.ok || result.status===422) throw new Error(result.description||text.error);
          message.textContent=text.success;message.dataset.error='false';document.dispatchEvent(new CustomEvent('cart:build'));
        } catch(error) {message.textContent=error.message||text.error;message.dataset.error='true';}
        finally {adding=false;button.removeAttribute('aria-busy');update();}
      });
    });
    let scheduled=false;
    const refresh=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;cards.forEach(c=>c.refresh());});};
    if(main){const grid=main.querySelector('[data-shade-grid]');if(grid){const observer=new MutationObserver(refresh);observer.observe(grid,{childList:true,subtree:true,characterData:true});root.ellaObserver=observer;}}
    document.addEventListener('variant:change',refresh);
  };
  const boot=()=>document.querySelectorAll('[data-ella-pairings]').forEach(initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-ella-pairings]').forEach(r=>r.ellaObserver?.disconnect()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ella-salonfinder"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{root.querySelectorAll('[data-salon-finder]').forEach(f=>{if(f.dataset.ready)return;f.dataset.ready='true';const q=f.querySelector('[data-esf-query]');if(!q)return;const cards=[...f.querySelectorAll('[data-esf-card]')];const norm=s=>s.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');const update=()=>{const terms=norm(q.value).trim().split(/\s+/).filter(Boolean);let count=0;cards.forEach(c=>{c.hidden=!terms.every(t=>norm(c.dataset.search).includes(t));if(!c.hidden)count++});f.querySelector('[data-esf-count]').textContent=count;f.querySelector('[data-esf-none]').hidden=count>0};q.addEventListener('input',update);f.querySelector('[data-esf-reset]').addEventListener('click',()=>{q.value='';update();q.focus()})})};init(document);document.addEventListener('shopify:section:load',e=>init(e.target.parentElement))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ella-salonpartner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function sync(root) {
    var field = root.querySelector('#ep-services');
    if (!field) return;
    var lines = field.value.split('\n').map(function (line) { return line.trim(); });
    root.querySelectorAll('[data-ep-service]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(lines.indexOf(button.dataset.epService) !== -1));
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ep-service]');
    if (!button) return;
    var root = button.closest('.ep');
    var field = root.querySelector('#ep-services');
    var label = button.dataset.epService;
    var lines = field.value.split('\n');
    var exists = lines.some(function (line) { return line.trim() === label; });
    if (exists) {
      lines = lines.filter(function (line) { return line.trim() !== label; });
    } else {
      lines.push(label);
    }
    field.value = lines.filter(function (line) { return line.trim() !== ''; }).join('\n');
    field.dispatchEvent(new Event('input', { bubbles: true }));
    sync(root);
  });
  document.addEventListener('input', function (event) {
    if (event.target.id === 'ep-services') sync(event.target.closest('.ep'));
  });
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.ep').forEach(sync);
  });
  document.querySelectorAll('.ep').forEach(sync);
})();

(function () {
  var key = 'ella.b2b.confirmation.v1';
  var maxAge = 30 * 60 * 1000;
  var busy = false;
  function read() {
    try {
      var value = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!value || Date.now() - value.created > maxAge) {
        sessionStorage.removeItem(key);
        return null;
      }
      return value;
    } catch (error) { return null; }
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.id !== 'EllaPartnerApplication' || !form.checkValidity()) return;
    var email = form.querySelector('#ep-email');
    var name = form.querySelector('#ep-name');
    if (!email || !name) return;
    var pending = read();
    var address = email.value.trim();
    var contactName = name.value.trim();
    if (!pending || pending.email !== address || pending.name !== contactName) {
      pending = {
        id: 'ella-b2b-' + crypto.randomUUID(),
        email: address,
        name: contactName,
        created: Date.now()
      };
    }
    try { sessionStorage.setItem(key, JSON.stringify(pending)); } catch (error) {}
    var reference = form.querySelector('[name="contact[Anfrage-ID]"]');
    if (!reference) {
      reference = document.createElement('input');
      reference.type = 'hidden';
      reference.name = 'contact[Anfrage-ID]';
      form.appendChild(reference);
    }
    reference.value = pending.id;
  }, true);
  async function deliver(attempt) {
    var marker = document.querySelector('#EllaPartnerApplication [data-ep-confirmed]');
    var pending = read();
    if (!marker || !pending || busy) return;
    var acceptedEmail = marker.dataset.epEmail.trim();
    if (acceptedEmail && acceptedEmail.toLowerCase() !== pending.email.toLowerCase()) return;
    busy = true;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 10000);
    try {
      var response = await fetch('https://a.klaviyo.com/client/events/?company_id=WGUv8i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-10-15' },
        signal: controller.signal,
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              unique_id: pending.id,
              time: new Date(pending.created).toISOString(),
              metric: { data: { type: 'metric', attributes: { name: 'ELLA B2B Partneranfrage eingegangen' } } },
              profile: { data: { type: 'profile', attributes: { email: pending.email } } },
              properties: {
                Ansprechpartner: pending.name,
                Anfragetyp: 'B2B-Partnerschaft',
                Anfrage_ID: pending.id,
                Quelle: 'Shopify Partnerformular',
                Shopify_erfolgreich: true
              }
            }
          }
        })
      });
      if (!response.ok) throw new Error('Event request failed');
      sessionStorage.removeItem(key);
      marker.dataset.epDelivery = 'accepted';
    } catch (error) {
      marker.dataset.epDelivery = 'pending';
      if (attempt < 2) setTimeout(function () { deliver(attempt + 1); }, (attempt + 1) * 4000);
    } finally {
      clearTimeout(timeout);
      busy = false;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { deliver(0); });
  else deliver(0);
  window.addEventListener('online', function () { deliver(0); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["felix-withdrawal"] && !Shopify.designMode) return;
  try {
    
function initWithdrawal(){
const form=document.getElementById('WithdrawalForm');
if(!form||form.dataset.ready)return;
form.dataset.ready='true';
const fields=document.getElementById('WithdrawalFields'),summary=document.getElementById('WithdrawalSummary');
if(!fields||!summary)return;
const name=document.getElementById('WithdrawalName'),email=document.getElementById('WithdrawalEmail'),contract=document.getElementById('WithdrawalContract');
document.getElementById('WithdrawalReview').addEventListener('click',()=>{
[name,email,contract].forEach(e=>e.value=e.value.trim());
if(!form.reportValidity())return;
document.getElementById('WithdrawalSummaryName').textContent=name.value;
document.getElementById('WithdrawalSummaryEmail').textContent=email.value;
document.getElementById('WithdrawalSummaryContract').textContent=contract.value;
document.getElementById('WithdrawalBody').value=document.getElementById('WithdrawalDeclaration').textContent+'\n\n'+name.value+'\n'+email.value+'\n'+contract.value;
fields.hidden=true;summary.hidden=false;document.getElementById('WithdrawalReviewHeading').focus();
});
document.getElementById('WithdrawalEdit').addEventListener('click',()=>{summary.hidden=true;fields.hidden=false;name.focus();});
form.addEventListener('submit',e=>e.preventDefault());
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initWithdrawal);else initWithdrawal();
document.addEventListener('shopify:section:load',initWithdrawal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ella-fast-hero')) {
  customElements.define('ella-fast-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      const start = () => {
        if (!video.getAttribute('src')) {
          video.src = window.matchMedia('(min-width: 769px)').matches ? this.dataset.desktopSrc : this.dataset.mobileSrc;
        }
        video.muted = true;
        video.play().catch(() => {});
      };
      video.addEventListener('playing', () => {
        this.setAttribute('data-playing', '');
        button.textContent = button.dataset.pauseLabel;
        button.setAttribute('aria-pressed', 'true');
      });
      video.addEventListener('pause', () => {
        button.textContent = button.dataset.playLabel;
        button.setAttribute('aria-pressed', 'false');
      });
      button.addEventListener('click', () => video.paused ? start() : video.pause());
      if (window.matchMedia('(min-width: 769px) and (prefers-reduced-motion: no-preference)').matches) {
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, {once:true});
      }
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
(() => {
  const setup = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’'\s.-]/g, '').trim();
    const source = root.querySelector('[data-brand-source]');
    const results = root.querySelector('[data-brand-results]');
    const input = root.querySelector('[data-brand-search]');
    const letters = root.querySelector('[data-brand-letters]');
    const count = root.querySelector('[data-brand-count]');
    const empty = root.querySelector('[data-brand-empty]');
    const logos = new Map();
    root.querySelectorAll('[data-popular-brand]').forEach(card => logos.set(normalize(card.dataset.popularBrand),card.querySelector('img')?.src));
    const seen = new Set();
    const brands = Array.from(source.querySelectorAll('a')).map(link => ({ name:link.textContent.trim(), href:link.href })).filter(brand => {
      const key = normalize(brand.name);
      if (key === 'loreal') { brand.name = "L’Oréal"; brand.href = '/search?type=product&q=' + encodeURIComponent("vendor:\"L'Oréal\" OR vendor:\"loreal\""); }
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    }).sort((a,b) => a.name.localeCompare(b.name,'de'));
    brands.forEach(brand => {
      brand.key = normalize(brand.name);
      brand.letter = /^[a-z]/.test(brand.key) ? brand.key[0].toUpperCase() : '#';
      const card = document.createElement('a');
      card.href = brand.href;
      const logo = logos.get(brand.key);
      if (logo) { const image = document.createElement('img'); image.src=logo; image.alt=''; image.loading='lazy'; image.width=152; image.height=88; card.append(image); }
      const name = document.createElement('span'); name.textContent=brand.name; card.append(name);
      const arrow = document.createElement('span'); arrow.textContent='›'; arrow.setAttribute('aria-hidden','true'); card.append(arrow);
      results.append(card);
      brand.card=card;
    });
    if (!brands.length) return;
    source.hidden=true;
    let active='Alle';
    const filter = () => {
      const query=normalize(input.value);
      let visible=0;
      brands.forEach(brand => { const show=brand.key.includes(query) && (active==='Alle' || active===brand.letter); brand.card.hidden=!show; if(show) visible++; });
      count.textContent=visible+' von '+brands.length+' Marken';
      empty.hidden=visible>0;
      letters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed',String(button.textContent===active)));
    };
    ['Alle','#',...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'].forEach(letter => {
      const button=document.createElement('button'); button.type='button'; button.textContent=letter;
      button.disabled=letter!=='Alle' && !brands.some(brand=>brand.letter===letter);
      button.addEventListener('click',()=>{active=letter;input.value='';filter();}); letters.append(button);
    });
    input.addEventListener('input',()=>{active='Alle';filter();});
    filter();
  };
  const init = () => document.querySelectorAll('[data-brand-directory]').forEach(setup);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
